export enum Notification {
    EMPTY_LABEL_NAME_ERROR = 0,
    NON_UNIQUE_LABEL_NAMES_ERROR = 1,
    MODEL_DOWNLOAD_ERROR = 2,
    MODEL_INFERENCE_ERROR = 3,
    MODEL_LOAD_ERROR = 4,
    LABELS_FILE_UPLOAD_ERROR = 5,
    ANNOTATION_FILE_PARSE_ERROR = 6,
    ANNOTATION_IMPORT_ASSERTION_ERROR = 7,
    UNSUPPORTED_INFERENCE_SERVER_MESSAGE = 8,
    ROBOFLOW_INFERENCE_SERVER_ERROR = 9,
}
